/**
 * Homepage Testimonials. Static for now — hand-picked diaspora quotes.
 *
 * No backend dependency; an admin-managed CMS for testimonials can come later
 * if you want to A/B test quotes for conversion lift.
 */
import { Quote, Star } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { flagFor } from "@/components/customer/CountryPicker";

const QUOTES = [
  {
    name: "Aisha O.",
    role: "Calling Lagos from London",
    country: "NG",
    quote: "I top up £5 and call Mum for 30+ minutes. With Boss Revolution I used to spend more than double. Audio is crystal clear.",
  },
  {
    name: "Kwame A.",
    role: "Calling Accra from Manchester",
    country: "GH",
    quote: "The per-second billing is what sold me — no rounding to the next minute, no surprise charges. Finally a fair telco.",
  },
  {
    name: "Amelia W.",
    role: "Calling Nairobi from Birmingham",
    country: "KE",
    quote: "Installed it on my iPhone in 10 seconds. Feels like a real phone app — saved contacts, recent calls, the works.",
  },
];

export default function HomeTestimonials() {
  return (
    <section className="bg-white" data-testid="testimonials-section">
      <div className="container-page py-16 lg:py-24">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-10">
            <p className="label-eyebrow text-brand-green">Trusted by the diaspora</p>
            <h2 className="mt-2 font-display font-black text-3xl sm:text-4xl text-brand-ink leading-tight">
              People who call home, <br className="hidden sm:inline" />
              <span className="text-brand-green">love calling home with us.</span>
            </h2>
          </div>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-5">
          {QUOTES.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.05}>
              <article
                data-testid={`testimonial-${i}`}
                className="h-full rounded-2xl border border-brand-line bg-white p-6 flex flex-col"
              >
                <Quote className="h-6 w-6 text-brand-green/40" />
                <p className="mt-3 text-sm text-brand-ink leading-relaxed flex-1">“{t.quote}”</p>
                <div className="mt-5 flex items-center gap-3 pt-4 border-t border-brand-line/60">
                  <div className="h-10 w-10 rounded-full bg-brand-greenSoft text-brand-greenDark flex items-center justify-center font-display font-black">
                    {t.name.charAt(0)}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-sm text-brand-ink truncate">{t.name}</p>
                    <p className="text-[11px] text-brand-muted truncate">{t.role}</p>
                  </div>
                  <span className="text-xl leading-none" aria-hidden>{flagFor(t.country)}</span>
                </div>
                <div className="mt-3 flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <Star key={`star-${j}`} className="h-3.5 w-3.5 fill-amber-400 stroke-amber-400" />
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
